<template>
  <div v-if="isVisible" class="modal show d-block fade" ref="create_user_form_modal" id="create_user_form_modal" tabindex="-1" style="background: rgba(0,0,0,0.5)">
    <div class="modal-dialog" >
      <div class="modal-content modal-thin-header">
        <div class="modal-header">
          <h5 class="modal-title">{{ title }}</h5>
          <button type="button" class="btn-close" @click="closeModal" ></button>
        </div>
        
        <div class="modal-body bg-white">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    title: {
      type: String,
      default: 'Fill In Form'
    },
    size: {
      type: String,
      default: 'modal-md' // can be modal-sm, modal-md, modal-lg, modal-xl
    }
  },
  data() {
    return {
      isVisible: false
    }
  },
  methods: {
    showModal() {
      this.isVisible = true
    },
    closeModal() {
      this.isVisible = false
    }
  }
}
</script>